// extracted by mini-css-extract-plugin
export default {"stack":"accept-invitation_stack__lym8C"};